import req from '../utils/request.js'

const api = {}

// 资源列表
api.list = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/WebResourceInfo/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 馆藏详情
api.info = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/WebResourceInfo/GetDetails', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 馆藏文件列表
api.sourceFiles = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webFileInfo/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 馆藏收藏
api.collect = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/api/userOperate/UserOperate', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 馆藏取消收藏
api.uncollect = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/api/userOperate/CancelUserOperate', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 统计数据
api.getStatisticsData = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webResourceInfo/GetStatisticsData', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default api
